module.exports = __webpack_public_path__ + "media/images/div_lens/inclusive-mobile-img2-46f4db84e8bc08fc384997c6c482b236.jpg";